"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagTypes = {
    dealership: 1,
    oem: 2
};
